export default "__VITE_ASSET__b8942cc9__"